// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy        from 'tippy.js';

export default class Tooltip extends WebComponent {
  didMount() {
    tippy(this.element, {
      arrow: true,
      theme: 'esp',
      allowHTML: true,
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Tooltip.js